import { useEffect, useState } from "react";

function readIsLandscape(): boolean {
  if (typeof window === "undefined") return false;

  const vv = window.visualViewport;
  const w = vv?.width ?? window.innerWidth;
  const h = vv?.height ?? window.innerHeight;
  if (w > h + 8) return true;

  const angle = window.screen?.orientation?.angle;
  if (angle === 90 || angle === 270 || angle === -90) return true;

  return window.matchMedia("(orientation: landscape)").matches;
}

/** True when viewport is wider than tall. */
export function usePhotoSessionOrientation() {
  const [isLandscape, setIsLandscape] = useState(readIsLandscape);

  useEffect(() => {
    const update = () => setIsLandscape(readIsLandscape());
    update();

    const mq = window.matchMedia("(orientation: landscape)");
    mq.addEventListener("change", update);
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    window.visualViewport?.addEventListener("resize", update);

    return () => {
      mq.removeEventListener("change", update);
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      window.visualViewport?.removeEventListener("resize", update);
    };
  }, []);

  return { isLandscape };
}
